var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTsSvg10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 28,
    viewBox: "0 0 136 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.577 20.5766C132.365 16.7886 132.365 10.647 128.577 6.85892C124.789 3.07087 118.647 3.07085 114.859 6.8589C111.071 10.6469 111.071 16.7886 114.859 20.5767C118.647 24.3647 124.789 24.3647 128.577 20.5766Z",
    strokeWidth: 1.7071,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5766 20.5766C96.3647 16.7886 96.3647 10.647 92.5766 6.85892C88.7886 3.07087 82.6469 3.07085 78.8589 6.8589C75.0708 10.6469 75.0708 16.7886 78.8589 20.5767C82.6469 24.3647 88.7886 24.3647 92.5766 20.5766Z",
    strokeWidth: 1.7071,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5766 20.5766C60.3647 16.7886 60.3647 10.647 56.5766 6.85892C52.7886 3.07087 46.6469 3.07085 42.8589 6.8589C39.0708 10.6469 39.0708 16.7886 42.8589 20.5767C46.6469 24.3647 52.7886 24.3647 56.5766 20.5766Z",
    strokeWidth: 1.7071,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5766 20.5766C24.3647 16.7886 24.3647 10.647 20.5766 6.85892C16.7886 3.07087 10.6469 3.07085 6.85888 6.8589C3.07083 10.6469 3.07083 16.7886 6.85888 20.5767C10.6469 24.3647 16.7886 24.3647 20.5766 20.5766Z",
    strokeWidth: 1.7071,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTsSvg10);
export default __webpack_public_path__ + "static/media/ts-svg-10.55aad016049edf2a42c4bef7b7071b88.svg";
export { ForwardRef as ReactComponent };